<script lang="ts" setup>
  const props = defineProps<{
    blok: any
  }>()

  const blokData = ref(props.blok)

  watch(
    () => props.blok,
    () => {
      blokData.value = props.blok
    }
  )
</script>

<template>
  <div class="mb-12 flex w-full flex-col px-4 md:mb-20 lg:px-0">
    <template
      v-for="block in blokData.body || []"
      :key="block._uid"
    >
      <StoryblokComponent :blok="block" />
    </template>
  </div>
</template>
